<template>
</template>
<script>
import XDate from 'xdate';

export default {
  data() {
    let vm = this;

    function getOptionsTime(maxLength) {
      let options = [];
      for (let i = 0; i <= maxLength; i++) {
        options.push({ name: i, value: i, selected: false, disabled: false });
      }
      return options;
    }

    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '300',
          max: '760',
          labelDesc: 'max-width-tablet',
          callback: function () {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';

            vm.applyChange(vm.element.internal_config);
          },
        },
        height: {
          name: 'height',
          defaultValue: '200',
          min: '100',
          max: '300',
          labelDesc: 'height',
          callback: function() {
            vm.resources.height.defaultValue = this.value;
            vm.element.internal_config.height = this.value + 'px';
            vm.element.rebuild();
          }
        },

        width: {
          name: 'width',
          defaultValue: '500',
          min: '100',
          max: '1000',
          labelDesc: 'width',
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + 'px';
            vm.element.rebuild();
            vm.applyChange(vm.element.internal_config);
          }
        },

        widthPanels: {
          name: 'widthPanels',
          defaultValue: '550',
          min: '300',
          max: '800',
          labelDesc: 'width',
          callback: function() {
            vm.resources.widthPanels.defaultValue = this.value;
            vm.element.internal_config.appearance.panels.width = this.value;
          }
        },

        numberTextStyle: {
          name: 'numberTextStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          // labelDesc: 'font-style-number',
          labelDesc: 'font-style',
          callback: function() {
            vm.resources.numberTextStyle.defaultFamily = this.family;
            vm.element.internal_config.numberTextStyle.family = this.family;

            vm.resources.numberTextStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.numberTextStyle.size = this.size + 'px';

            vm.resources.numberTextStyle.defaultColor = this.color;
            vm.element.internal_config.numberTextStyle.color = this.color;

            vm.resources.numberTextStyle.defaultAlign = this.align;
            vm.element.internal_config.numberTextStyle.align = this.align;

            vm.resources.numberTextStyle.defaultWeight = this.weight;
            vm.element.internal_config.numberTextStyle.weight = this.weight;

            vm.resources.numberTextStyle.defaultStyle = this.style;
            vm.element.internal_config.numberTextStyle.style = this.style;

            vm.applyChange(vm.element.internal_config);
          }
        },
        labelTextStyle: {
          name: 'labelTextStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          // labelDesc: 'font-style-label',
          labelDesc: 'font-style',
          callback: function() {
            vm.resources.labelTextStyle.defaultFamily = this.family;
            vm.element.internal_config.labelTextStyle.family = this.family;

            vm.resources.labelTextStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.labelTextStyle.size = this.size + 'px';

            vm.resources.labelTextStyle.defaultColor = this.color;
            vm.element.internal_config.labelTextStyle.color = this.color;

            vm.resources.labelTextStyle.defaultAlign = this.align;
            vm.element.internal_config.labelTextStyle.align = this.align;

            vm.resources.labelTextStyle.defaultWeight = this.weight;
            vm.element.internal_config.labelTextStyle.weight = this.weight;

            vm.resources.labelTextStyle.defaultStyle = this.style;
            vm.element.internal_config.labelTextStyle.style = this.style;

            vm.applyChange(vm.element.internal_config);
          }
        },

        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#333',
          labelDesc: 'resource-bg-color',
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue.substring(0, 7);
            vm.element.internal_config.appearance[vm.element.internal_config.theme].backgroundColor = this.colorValue.substring(0, 7);

            vm.applyChange(vm.element.internal_config);
          }
        },

        backgroundColorEffect: {
          name: 'backgroundColorEffect',
          defaultValue: '#333',
          labelDesc: 'resource-bg-color-effect',
          callback: function() {
            vm.resources.backgroundColorEffect.defaultValue = this.colorValue.substring(0, 7);
            vm.element.internal_config.appearance[vm.element.internal_config.theme].backgroundColorEffect = this.colorValue.substring(0, 7);

            vm.applyChange(vm.element.internal_config);
          }
        },

        fontColor: {
          name: 'fontColor',
          defaultValue: '#333',
          labelDesc: 'resource-font-color',
          callback: function() {
            vm.resources.fontColor.defaultValue = this.colorValue.substring(0, 7);

            if (vm.element.internal_config.appearance[vm.element.internal_config.theme] && vm.element.internal_config.appearance[vm.element.internal_config.theme].fontColor) {
              vm.element.internal_config.appearance[vm.element.internal_config.theme].fontColor = this.colorValue.substring(0, 7);
            }

            vm.applyChange(vm.element.internal_config);
          }
        },

        fontColorLabel: {
          name: 'fontColorLabel',
          defaultValue: '#333',
          labelDesc: 'resource-font-label-color',
          callback: function() {
            vm.resources.fontColorLabel.defaultValue = this.colorValue.substring(0, 7);
            vm.element.internal_config.appearance.panels.fontColorLabel = this.colorValue.substring(0, 7);

            vm.applyChange(vm.element.internal_config);
          }
        },

        descTextStyle: {
          name: 'descTextStyle',
          defaultValue: '#333',
          labelDesc: 'resource-font-desc-color',
          callback: function() {
            if (vm.element.internal_config.appearance[vm.element.internal_config.theme] && vm.element.internal_config.appearance[vm.element.internal_config.theme].fontDesc) {
              vm.resources.descTextStyle.defaultFamily = this.family;
              vm.element.internal_config.appearance.text.fontDesc.family = this.family;

              vm.resources.descTextStyle.defaultSize = this.size + 'px';
              vm.element.internal_config.appearance.text.fontDesc.size = this.size + 'px';

              vm.resources.descTextStyle.defaultColor = this.color;
              vm.element.internal_config.appearance.text.fontDesc.color = this.color;

              vm.resources.descTextStyle.defaultAlign = this.align;
              vm.element.internal_config.appearance.text.fontDesc.align = this.align;

              vm.resources.descTextStyle.defaultWeight = this.weight;
              vm.element.internal_config.appearance.text.fontDesc.weight = this.weight;

              vm.resources.descTextStyle.defaultStyle = this.style;
              vm.element.internal_config.appearance.text.fontDesc.style = this.style;
            }

            vm.applyChange(vm.element.internal_config);
          }
        },

        theme: {
          name: 'theme',
          defaultValue: '',
          labelDesc: 'theme',
          options: [
            { name: vm.$t('ct-option-timer-theme-panels'), value: 'panels', selected: 'selected', disabled: false},
            { name: vm.$t('ct-option-timer-theme-circles'), value: 'circles', selected: false, disabled: false },
            { name: vm.$t('ct-option-timer-theme-squares'), value: 'squares', selected: false, disabled: false },
            { name: vm.$t('ct-option-timer-theme-text'), value: 'text', selected: false, disabled: false },
            { name: vm.$t('ct-option-timer-theme-simple'), value: 'simple', selected: false, disabled: false },
            { name: vm.$t('ct-option-timer-theme-pill'), value: 'pill', selected: false, disabled: false }
          ],
          callback: function() {
            vm.resources.theme.defaultValue = this.value;
            vm.element.internal_config.theme = this.value;

            // vm.setValuesData(vm.element);
            vm.applyChange(vm.element.internal_config);
            vm.element.rebuild();
          }
        },

        type: {
          name: 'type',
          defaultValue: '',
          labelDesc: 'type',
          options: [
            { name: vm.$t('ct-option-timer-type-until-date-specifies'), value: 'decrease_date_end', selected: false, disabled: false },
            { name: vm.$t('ct-option-timer-type-sum-interval-hours'), value: 'decrease_sum_time', selected: false, disabled: false },
            { name: vm.$t('ct-option-timer-type-evergreen'), value: 'decrease_sum_time_user_start', selected: false, disabled: false },
            { name: vm.$t('ct-option-timer-type-sum-time-user'), value: 'start_user_every_access', selected: false, disabled: false }
          ],
          callback: function() {
            vm.resources.type.defaultValue = this.value;
            vm.element.internal_config.type = this.value;

            vm.element.internal_config.settings.days_to_sum = 1;
            vm.element.internal_config.settings.hours_to_sum = 0;
            vm.element.internal_config.settings.minutes_to_sum = 0;
            vm.element.internal_config.settings.seconds_to_sum = 0;

            vm.applyChange(vm.element.internal_config);
            vm.element.rebuild();
          }
        },
        date: {
          name: 'date',
          defaultValue: '',
          labelDesc: 'date-end',
          callback: function() {
            vm.resources.date.defaultValue = this.value;
            vm.element.internal_config.date_end = this.value;

            vm.applyChange(vm.element.internal_config);
            vm.element.rebuild();
          }
        },
        textDescription: {
          name: 'textDescription',
          defaultValue: '',
          labelDesc: 'textDescription',
          callback: function() {
            vm.resources.textDescription.defaultValue = this.value;
            vm.element.internal_config.textDescription = this.value;

            vm.applyChange(vm.element.internal_config);
            vm.element.rebuild();
          }
        },
        days: {
          name: 'days',
          defaultValue: '',
          labelDesc: 'days',
          callback: function() {
            vm.resources.days.defaultValue = this.value;
            vm.element.internal_config.days = this.value;

            vm.applyChange(vm.element.internal_config);
          }
        },
        hours: {
          name: 'hours',
          defaultValue: '',
          labelDesc: 'hours',
          options: getOptionsTime(24),
          callback: function() {
            vm.resources.hours.defaultValue = this.value;
            vm.element.internal_config.hours = this.value;

            vm.applyChange(vm.element.internal_config);
          }
        },
        minutes: {
          name: 'minutes',
          defaultValue: '',
          labelDesc: 'minutes',
          options: getOptionsTime(58),
          callback: function() {
            vm.resources.minutes.defaultValue = this.value;
            vm.element.internal_config.minutes = this.value;

            vm.applyChange(vm.element.internal_config);
          }
        },
        seconds: {
          name: 'seconds',
          defaultValue: '',
          labelDesc: 'seconds',
          options: getOptionsTime(59),
          callback: function() {
            vm.resources.seconds.defaultValue = this.value;
            vm.element.internal_config.seconds = this.value;

            vm.applyChange(vm.element.internal_config);
          }
        }
      }
    };
  },

  methods: {
    setValue(resourcesType, internalConfig = '', defaultValue = 'defaultValue') {
      var value = internalConfig || resourcesType;
      this.resources[resourcesType][defaultValue] = this.element.internal_config[value];
    },
    setValuesData(data) {
      this.element = data;
      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

      this.setValue('theme');
      this.setValue('type');
      this.setValue('date', 'date_end');
      this.setValue('days');
      this.setValue('hours');
      this.setValue('minutes');
      this.setValue('seconds');

      this.resources.height.defaultValue = parseInt(data.internal_config.height);
	    this.resources.width.defaultValue = parseInt(data.internal_config.width);

      this.resources.labelTextStyle.defaultFamily = data.internal_config.labelTextStyle.family;
      this.resources.labelTextStyle.defaultSize = data.internal_config.labelTextStyle.size;
      this.resources.labelTextStyle.defaultColor = data.internal_config.labelTextStyle.color;
      this.resources.labelTextStyle.defaultAlign = data.internal_config.labelTextStyle.align;
      this.resources.labelTextStyle.defaultWeight = data.internal_config.labelTextStyle.weight;
      this.resources.labelTextStyle.defaultStyle = data.internal_config.labelTextStyle.style;

      this.resources.numberTextStyle.defaultFamily = data.internal_config.numberTextStyle.family;
      this.resources.numberTextStyle.defaultSize = data.internal_config.numberTextStyle.size;
      this.resources.numberTextStyle.defaultColor = data.internal_config.numberTextStyle.color;
      this.resources.numberTextStyle.defaultAlign = data.internal_config.numberTextStyle.align;
      this.resources.numberTextStyle.defaultWeight = data.internal_config.numberTextStyle.weight;
      this.resources.numberTextStyle.defaultStyle = data.internal_config.numberTextStyle.style;

      if (data.internal_config.appearance.text && data.internal_config.appearance.text.fontDesc) {
        this.resources.descTextStyle.defaultFamily = data.internal_config.appearance.text.fontDesc.family;
        this.resources.descTextStyle.defaultSize = data.internal_config.appearance.text.fontDesc.size;
        this.resources.descTextStyle.defaultColor = data.internal_config.appearance.text.fontDesc.color;
        this.resources.descTextStyle.defaultAlign = data.internal_config.appearance.text.fontDesc.align;
        this.resources.descTextStyle.defaultWeight = data.internal_config.appearance.text.fontDesc.weight;
        this.resources.descTextStyle.defaultStyle = data.internal_config.appearance.text.fontDesc.style;
      }

      if (data.internal_config.appearance[data.internal_config.theme] && data.internal_config.appearance[data.internal_config.theme].backgroundColor) {
        this.resources.backgroundColor.defaultValue = data.internal_config.appearance[data.internal_config.theme].backgroundColor;
      }

      if (data.internal_config.appearance[data.internal_config.theme] && data.internal_config.appearance[data.internal_config.theme].backgroundColorEffect) {
        this.resources.backgroundColorEffect.defaultValue = data.internal_config.appearance[data.internal_config.theme].backgroundColorEffect;
      }

      if (data.internal_config.appearance[data.internal_config.theme] && data.internal_config.appearance[data.internal_config.theme].fontColor) { this.resources.fontColor.defaultValue = data.internal_config.appearance[data.internal_config.theme].fontColor }

      this.resources.fontColorLabel.defaultValue = data.internal_config.appearance.panels.fontColorLabel;
    },
    getValuesData() {
      return this.resources;
    },

    getSumDate(config, gmt) {
      let date = gmt ? XDate(true) : XDate();

      return date
        .addDays(config.days)
        .addHours(config.hours)
        .addMinutes(config.minutes)
        .addSeconds(config.seconds)
        .toString();
    },

    applyChange(internal_config) {
      if (this.element.internal_config.type === 'decrease_sum_time_user_start' || this.element.internal_config.type === 'decrease_sum_time' || this.element.internal_config.type === 'start_user_every_access') {
        internal_config.settings.save_time = XDate().toString();
      }

      internal_config.settings.original_minutes_finish = internal_config.minutes;
      internal_config.settings.original_hours_finish = internal_config.hours;

      internal_config.settings.minutes_to_sum = internal_config.minutes;
      internal_config.settings.days_to_sum = internal_config.days;
      internal_config.settings.hours_to_sum = internal_config.hours;
      internal_config.settings.seconds_to_sum = internal_config.seconds;

      internal_config.settings.original_minutes_finish = internal_config.minutes;
      internal_config.settings.original_hours_finish = internal_config.hours;

      internal_config.settings.minutes_to_sum = internal_config.minutes;
      internal_config.settings.days_to_sum = internal_config.days;
      internal_config.settings.hours_to_sum = internal_config.hours;
      internal_config.settings.seconds_to_sum = internal_config.seconds;

      var now = XDate().toString();
      var gtm = now.substr(now.indexOf('GMT'), 8);

      internal_config.settings.gmt_save = gtm;

      switch (internal_config.type) {
        case 'decrease_date_end': // Até Data Especifica

          internal_config.settings.original_date_finish = XDate(XDate(internal_config.date_end))
            .addHours(internal_config.settings.original_hours_finish)
            .addMinutes(internal_config.settings.original_minutes_finish)
            .toString();

          let date = XDate();
          let dateGTM0 = XDate(true);

          let diffSecondsTotal = XDate(dateGTM0).diffSeconds(XDate(date));

          internal_config.settings.original_date_finish_gmt0 = XDate(internal_config.settings.original_date_finish).addSeconds(diffSecondsTotal * (-1)).toString();

          break;

        case 'decrease_sum_time': // Contas até intervalo de Horas
          if (typeof internal_config.settings.save_time === 'undefined') {
            internal_config.settings.save_time = XDate().toString();
          }

          internal_config.settings.original_date_finish = this.getSumDate(internal_config, false);
          internal_config.settings.original_date_finish_gmt0 = this.getSumDate(internal_config, true);
          break;

        case 'decrease_sum_time_user_start': // Evergreen
        case 'start_user_every_access': // Contar tempo em todo acesso do usuario
          if (typeof internal_config.settings.save_time === 'undefined') {
            internal_config.settings.save_time = XDate().toString();
            internal_config.settings.original_date_finish_gmt0 = XDate(true).toString();
          }
          break;
        default:
          break;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Timer/Resources.vue